export default __webpack_public_path__ + "static/media/research.0a8d5ec0.jpg";